import {Component, Input, OnInit} from '@angular/core';
import {EmployeeDesignationService} from '../../../../shared/service/employee-designation.service';
import {EmployeeDesignationDTO} from '../../../../shared/dto/employee-designation.model';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {EmployeeDesignationComponent} from '../employee-designation.component';
import {EmployeeDesignationPopupComponent} from '../employee-designation-popup/employee-designation-popup.component';
import {ActionMode} from '../../../../shared/enums/action-mode.enum';
import swal from 'sweetalert2';

@Component({
  selector: 'app-employee-designation-search-table',
  templateUrl: './employee-designation-search-table.component.html',
  styleUrls: ['./employee-designation-search-table.component.scss']
})
export class EmployeeDesignationSearchTableComponent implements OnInit {
  @Input() items: EmployeeDesignationDTO[];
  @Input() index: number;
  @Input() page: number = 1;
  @Input() itemsPerPage: number = 5;
  private employeeDesignationDTOS: EmployeeDesignationDTO [] = [];

  constructor(private employeeDesignationService: EmployeeDesignationService,
              public modalService: NgbModal,
              private employeeDesignationMgt: EmployeeDesignationComponent) {
  }

  ngOnInit() {
    this.loadEmployeeDesignations();
  }

  loadEmployeeDesignations() {
    this.employeeDesignationService.getAllEmployeeDesignation().subscribe(
      (data: EmployeeDesignationDTO[]) => {
        this.employeeDesignationDTOS = data;
      }
    )
  }

  onClickUpdate(Item) {
    const modalRef = this.modalService.open(EmployeeDesignationPopupComponent, {
      windowClass: 'xlModal'
    });
    modalRef.componentInstance.name = 'Update Employee Designation Details';
    modalRef.componentInstance.code = Item.employeeDesignationCode;
    modalRef.componentInstance.description = Item.description;
    modalRef.componentInstance.selectedState = Item.status;
    modalRef.componentInstance.designationMgtCopy_ = Item;
    modalRef.componentInstance.selectedMode = ActionMode.UPDATE;
    modalRef.result.then(
      (data: string) => {
        if (data == 'Saved') {
          this.employeeDesignationMgt.onLoadGetData();
        }
      },
      () => {
      }
    );
  }

  onDelete(Item) {
    swal.fire({
      title: 'Are you sure, you want to delete?',
      text: '',
      showCancelButton: true,

      confirmButtonText: 'Yes'
    }).then(
      (result) => {
        if (result.value) {
          this.employeeDesignationService.deleteDesignation(Item.employeeDesignationCode).subscribe(
            (res: boolean) => {
              if (res === true) {
                swal.fire('Success', 'Details Deleted successfully', 'success');
                this.items.splice(Item, 1);
                this.loadEmployeeDesignations();
              } else if (res === false) {
                swal.fire('Sorry!', 'Details can\'t be deleted...!', 'error');
              }
            },
            (error) => {
              console.log(error);
              swal.fire('Sorry!', 'Something went wrong...!', 'error');
            },
            () => {
              this.loadEmployeeDesignations();
            }
          );
        }
      }, reason => {
      }
    );
  }

  onClickView(Item) {
    const modalRef = this.modalService.open(EmployeeDesignationPopupComponent, {
      windowClass: 'xlModal'
    });
    modalRef.componentInstance.name = 'View Employee Designation Details';
    modalRef.componentInstance.code = Item.employeeDesignationCode;
    modalRef.componentInstance.description = Item.description;
    modalRef.componentInstance.selectedState = Item.status;
    modalRef.componentInstance.designationMgtCopy_ = Item;
    modalRef.componentInstance.selectedMode = ActionMode.VIEW;
  }

}
